<template>
    <div>
 <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="indigo darken-2"
          dark
          v-bind="attrs"
          v-on="on"
        >
          <v-icon left small>mdi-calendar-plus</v-icon>
          Agendar horário
        </v-btn>
          
          
      </template>

      <v-card>
        <v-card-title class="headline blue lighten-2 mb-5">
          Agendar novo horário
        </v-card-title>

        <v-card-text>
          Adicione aqui seu agendamento manual
        </v-card-text>
         

        <v-form ref="form" v-model="valid">
            <v-row justify="center" >
            <v-col cols="10" sm="10" >
            <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                >

                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="date"
                    label="Escolha o dia"
                    prepend-icon="fa fa-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                   :rules="fieldRules"
                    required
                ></v-text-field>
                </template>
                
                <v-date-picker
                locale="pt-br"               
                v-model="date"
                :min="new Date(Date.now() - 86400000).toISOString().substr(0, 10)"
                @change="$refs.menu.save(date)"
                ></v-date-picker>

              
            </v-menu>

                <v-text-field
                    v-model="usuario.nome"
                    label="Nome do cliente"
                    prepend-icon="mdi-account"
                    required
                ></v-text-field>

                <v-text-field
                    v-model="usuario.email"
                    label="Digite o e-mail"
                    prepend-icon="mdi-email"
                
                    required
                ></v-text-field>

              <v-text-field label="Telefone" v-mask="'(##)#####-####'" type="text" prepend-icon="fa fa-phone" 
              placeholder="(00)00000-0000 " v-model="usuario.telefone" ></v-text-field> 







                <v-select
                    v-model="barbeirosEscolhido"
                     item-text="nome"
                     item-value="id"
                    :items="barbeiros"
                    chips
                    label="Selecione o barbeiro"
                    prepend-icon="mdi-account"
                    solo
                ></v-select>

                  <v-select  :items="servicos" item-text="descTempo" 
                    item-value="id" v-model="servicoEscolhido"  
                    label="Serviços" prepend-icon="mdi-share"  >
                  </v-select>
            </v-col>
            <v-col cols="5" sm="5" >  
                <v-text-field type="time" :rules="fieldRules" v-model="horaInit" label="Horário início" ></v-text-field>
            </v-col>
            <v-col cols="5" sm="5" >  
                <v-text-field type="time" :rules="fieldRules" v-model="horaFim" label="Horário fim" ></v-text-field>
            </v-col>
        </v-row>
        </v-form>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary" :loading="salvando" :disabled="!valid || salvando"
            @click="agendarHorario"
          >
            Gravar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
import {refFuncoes, refBarbeiros} from '@/firebaseConfig'
import { criarAgendamentoNoPortal } from '@/services/agendaFirestore'

    export default {
        data(){
            return {
                valid: true,
                refBarbeiros: refBarbeiros,
                refFuncoes: refFuncoes,
                salvando: false,
                servicos: [],
                servicoEscolhido: '',
                usuario: {},
                dialog: false,
                barbeiros: [],
                barbeirosEscolhido: '',
                barbeiroEscolhidoObjeto: {},
                cliente: {},
                horaInit: '',
                horaFim: '',
                date: '',
                menu: '',
                fieldRules: [
                    v => !!v || 'Este campo é obrigatório',
                    
                ],

            }
        },
        created(){
            this.carregarBarbeiros()
            this.carregarServicos()
        },
        methods: {
            carregarBarbeiros(){
                this.refBarbeiros.get().then((snap)=> {
                    snap.forEach((doc)=>{
                        this.barbeiros.push({...doc.data()})
                    });
                });
            },
            
            carregarServicos(){
              console.log(this.refServicos)
              this.refFuncoes.orderBy("descricao","asc").get().then((snap)=>{
                snap.forEach((doc)=>{
                  var descricaoTempo = doc.data().descricao + " - " + doc.data().tempo.replace("m","min.") + " - R$ " +  doc.data().preco.toLocaleString()
                  this.servicos.push({...doc.data(), descTempo: descricaoTempo});
                });

              });
            },

        async agendarHorario(){
            if(this.salvando){
                return
            }

            this.salvando = true
            try {
                const barbeiro = this.barbeiros.find(
                    item => item.id === this.barbeirosEscolhido
                )
                const servico = this.filtrarServico(this.servicoEscolhido)
                await criarAgendamentoNoPortal({
                    barbeiro: {...barbeiro},
                    servico: {...servico},
                    cliente: {...this.usuario},
                    name: this.usuario.nome,
                    start: this.date + "T" + this.horaInit,
                    end: this.date + "T" + this.horaFim,
                    dataQuery: new Date(this.date + "T00:00-03:00").getTime(),
                    status: "Pendente",
                })

                this.$emit('recarregarLista')
                this.barbeirosEscolhido = ''
                this.servicoEscolhido = ''
                this.usuario = {}
                this.date = ''
                this.horaInit = ''
                this.horaFim = ''
                this.dialog = false
            } catch (error) {
                this.$toasted.global.defaultError({ msg: error.message })
            } finally {
                this.salvando = false
            }
          },

          filtrarServico(){
            return this.servicos.find(servico => {
                  if(servico.id == this.servicoEscolhido){
                    return servico;
                  }});
            },

          
        }
    }
</script>

<style lang="scss" scoped>

</style>
